import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, interval } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AutomaticRateService {
  API_URL = environment.apiGatewayURL;
  private readonly RATE_UPDATE_INTERVAL = 30000; // 30 seconds

  constructor(private http: HttpClient) {}

  getRateUpdates(): Observable<number> {
    return interval(this.RATE_UPDATE_INTERVAL).pipe(
      switchMap(() => this.getUsdtRateForUser()),
      map((response) => response?.valoresCambio?.tasaUsdtClp)
    );
  }
  getRateSellUpdates(): Observable<number> {
    return interval(this.RATE_UPDATE_INTERVAL).pipe(
      switchMap(() => this.getUsdtRateSellForUser()),
      map((response) => response?.valoresCambio?.tasaUsdtClp)
    );
  }

  getAutomaticRate() {
    const serviceURL = `${this.API_URL}usdt-rate-preview`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getAutomaticRateSales() {
    const serviceURL = `${this.API_URL}usdt-sales-rate-preview`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getUsdtRateForUser(): Promise<any> {
    const serviceURL = `${this.API_URL}general-types/usdtRate`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }
  getUsdtRateSellForUser(): Promise<any> {
    const serviceURL = `${this.API_URL}general-types/usdtRateSell`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }
}
